export function inputAddError(formEl,addErrorEls) {
  if ($(formEl).length) {
    const hasErrorEl = $(formEl).find(".error");
    if (hasErrorEl.length) {
      $(formEl).addClass("isError");
      $(hasErrorEl).each(function () {
        addErrorEls.map((el) => {
          $(this).parents(el).addClass("isError");
        })
      })
    }
  }
}
